/* eslint-disable react/jsx-key */
import React from 'react';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { AppointmentTypes } from './components/AppointmentTypes';
import { EnableAppointment } from './components/EnableAppointment';
import { AppointmentMessages } from './components/AppointmentMessages';

export const AppointmentsSettings = () => {
  return (
    <StandardLayoutV2
      title="Appointments"
      classProps="flex-col-left"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent' }}
    >
      <AppointmentMessages />
      <AppointmentTypes />
      <EnableAppointment />
    </StandardLayoutV2>
  );
};
